// ViewPermission.js
import React, { useEffect } from "react";
import { Close, CheckCircle, CancelCircle } from "../../assets/svg";
import CustomTable from "../customTable/CustomTable";
import { DefaultButton } from "../../components/micro/input";
import { useDispatch, useSelector } from "react-redux";
import { getPermissionsList } from "../../redux/accounts/slice";
import RippleLoader from "../RippleLoader/RippleLoader";

const ViewPermission = ({
  setViewPermissionListPopup,
  viewPermissionData,
  setAddEditRolePopup,
}) => {
  const dispatch = useDispatch();
  const permissionList = {
    data: [
      {
        taskName: "Module 1",
      },
    ],
  };

  const { permissionsList, permissionListLoading } = useSelector((store) => ({
    permissionsList: store?.accountsData?.getPermissionsListStatus?.data,
    permissionListLoading: store?.accountsData?.loading,
  }));

  useEffect(() => {
    dispatch(getPermissionsList(viewPermissionData.id));
  }, [dispatch, viewPermissionData]);

  const ColumnHeaders = () => {
    return (
      <>
        <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
          Head
        </th>
        <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
          Create
        </th>
        <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
          Update
        </th>
        <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
          Read
        </th>
        <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
          Delete
        </th>
      </>
    );
  };

  const DataRows = () => {
    return (
      <>
        {(permissionsList?.data || [])?.map((element) => (
          <>
            {!element?.sub_menu?.length ? (
              <tr
                className={"border-b border-b-Grey text-sm font-Proxima"}
                key={element?.id}
              >
                <td className="px-5 py-3">{element?.title}</td>
                {element?.child_permission?.map((child_permission) => {
                  return (
                    <td className="px-5 py-3">
                      {child_permission?.assigned ? (
                        <CheckCircle />
                      ) : (
                        <CancelCircle />
                      )}
                    </td>
                  );
                })}
              </tr>
            ) : (
              <>
                <tr className="text-sm font-Proxima">
                  <td className="px-5 py-3">{element?.title}:</td>
                </tr>
                {element?.sub_menu?.map((sub, index) => {
                  return (
                    <tr
                      className={`${
                        element?.sub_menu?.length - 1 === index &&
                        "border-b border-b-Grey"
                      } text-sm font-Proxima`}
                    >
                      <td className="px-5 py-3">{sub?.title}</td>
                      {sub?.child_permission?.map((child_permission) => {
                        return (
                          <td className="px-5 py-3">
                            {child_permission?.assigned ? (
                              <CheckCircle />
                            ) : (
                              <CancelCircle />
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </>
            )}
          </>
        ))}
      </>
    );
  };

  return (
    <div
      className="model"
      onClick={() => {
        setViewPermissionListPopup(false);
      }}
    >
      <div
        className="bg-white flex flex-col items-end justify-center drop-shadow-lg rounded-lg w-full max-w-xl min-h-36 py-5 px-6 mx-auto relative"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <p className="text-xl font-Montserrat font-medium w-full border-b-Grey border-b pb-3 mb-4 capitalize">
          {viewPermissionData?.title}
        </p>
        <Close
          className="cursor-pointer absolute top-5 right-5"
          onClick={() => {
            setViewPermissionListPopup(false);
          }}
        />
        {permissionListLoading ? (
          <div className="w-full h-96 flex justify-center items-center">
            <RippleLoader />
          </div>
        ) : (
          <div className="w-full max-h-96 overflow-auto mb-3">
            <CustomTable
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={permissionList}
              loading={false}
            />
          </div>
        )}
        <DefaultButton
          className="btn-theme"
          value="Edit"
          onClick={() => {
            setViewPermissionListPopup(false);
            setAddEditRolePopup(true);
          }}
        >
          Edit
        </DefaultButton>
      </div>
    </div>
  );
};

export default ViewPermission;
